import { PdpSpuType } from "../utils/lynkco-constants";
export const setCarePlanDisclaimer = orderItems => {
  const carePlanList = (orderItems || []).filter(item => item.tag === PdpSpuType.servicePackage)[0];
  let carePlanDisclaimer = "",
    carePlanDisclaimerArr = [];
  (carePlanList?.materialInfoVos || []).forEach(materialInfoVo => {
    carePlanDisclaimerArr.push(materialInfoVo.materialName);
  });
  carePlanDisclaimer = carePlanDisclaimerArr.join(",");
  return carePlanDisclaimer;
};
export const setWheelServiceDisclaimer = orderItems => {
  const wheelServiceList = (orderItems || []).filter(item => item.tag === PdpSpuType.wheelsService)[0];
  let wheelServiceDisclaimer = "",
    wheelServiceDisclaimerArr = [];
  (wheelServiceList?.materialInfoVos || []).forEach(materialInfoVo => {
    wheelServiceDisclaimerArr.push(materialInfoVo.materialName);
  });
  wheelServiceDisclaimer = wheelServiceDisclaimerArr.join(",");
  return wheelServiceDisclaimer;
};
export const setDisclaimer = orderPreview => {
  let orderItems = orderPreview?.orderItems || orderPreview?.suborders[0]?.orderItems;
  let wheelServiceDisclaimer = setWheelServiceDisclaimer(orderItems);
  let carePlanDisclaimer = setCarePlanDisclaimer(orderItems);
  return { wheelServiceDisclaimer, carePlanDisclaimer };
}
